/**
 * @returns {string|null}
 */
import { FACT_ATTRIBUTE_IDS } from './constants'

export function getTrackingFactLabel (componentBlueprint, factsheetBlueprint) {
  const defId = componentBlueprint.id
  const fact = factsheetBlueprint.factTree.facts[defId]
  return getComponentLabel(
    componentBlueprint,
    fact) + ' (' + defId + ')'
}

export function getComponentLabel (componentBlueprint, factTreeElement) {
  if (componentBlueprint.hasOwnProperty('label')) {
    return componentBlueprint.label
  }
  return factTreeElement.label
}

/**
 * @returns {string|null}
 */
export function getComponentDefinition (componentBlueprint, factTreeElement) {
  if (componentBlueprint.hasOwnProperty('definition')) {
    return componentBlueprint.definition
  }
  return factTreeElement.definition
}

/**
 * @returns {string|null}
 */
export function getComponentType (componentBlueprint, factTreeElement) {
  if (componentBlueprint.hasOwnProperty('value') && componentBlueprint.value.hasOwnProperty('type')) {
    return componentBlueprint.value.type
  }
  if (factTreeElement.hasOwnProperty('value') && factTreeElement.value.hasOwnProperty('type')) {
    return factTreeElement.value.type
  }
  return null
}

/**
 * @returns {object}
 */
export function getAttributeRequired (componentBlueprint, factTreeElementAttribute, factTreeElementFact) {
  const required = {
    attribute: false,
    value: false
  }
  if (factTreeElementFact.hasOwnProperty('attributes')) {
    for (const attribute of factTreeElementFact.attributes) {
      if (attribute.id === componentBlueprint.id) {
        if (attribute.hasOwnProperty('required')) {
          required.attribute = attribute.required
        }
        break
      }
    }
  }
  if (factTreeElementAttribute.hasOwnProperty('value') && factTreeElementAttribute.value.hasOwnProperty('required')) {
    required.value = factTreeElementAttribute.value.required
  }
  if (componentBlueprint.hasOwnProperty('required')) {
    required.attribute = componentBlueprint.required
  }
  if (componentBlueprint.hasOwnProperty('value') && componentBlueprint.value.hasOwnProperty('required')) {
    required.value = componentBlueprint.value.required
  }
  return required
}

export function getFactInstanceName (factInstance, factInstanceKey, defaultLabel = null) {
  const hasNameAttribute = factInstance.hasOwnProperty('attributes') && factInstance.attributes.hasOwnProperty(
    FACT_ATTRIBUTE_IDS.ATTRIBUTE_NAME
  )
  if (!hasNameAttribute) {
    return defaultLabel + ' #' + (factInstanceKey + 1)
  }
  const nameAttribute = factInstance.attributes[FACT_ATTRIBUTE_IDS.ATTRIBUTE_NAME]
  if (nameAttribute.value !== '') {
    return nameAttribute.value
  }
  return defaultLabel + ' #' + (factInstanceKey + 1)
}

export function filterObject (obj, callback) {
  return Object.fromEntries(Object.entries(obj).filter(([key, val]) => callback(val, key)))
}

/**
 * Recursively searches for a fact component by its ID within a blueprint object.
 *
 * @param {Object} blueprint - The blueprint object containing component structures to search within.
 * @param {string|number} factId - The ID of the fact component to find.
 * @return {Object|null} - Returns the fact component object if found, otherwise returns null.
 */
export function findFactComponentById (blueprint, factId) {
  if (!blueprint.hasOwnProperty('components')) {
    return null
  }
  for (let i = 0; i < blueprint.components.length; i++) {
    const component = blueprint.components[i]
    if (component.id === String(factId) && component.type.startsWith('fact:')) {
      return component
    }
    if (!component.hasOwnProperty('components')) {
      continue
    }
    const found = findFactComponentById(component, factId)
    if (found) {
      return found
    }
  }
  return null
}
